import clsx from 'clsx';
import React, { LiHTMLAttributes } from 'react';

import { DropdownListProps } from '../dropdown-list/DropdownList';
import styles from './DropdownListOption.module.scss';

interface DropdownListOptionProps<T>
  extends LiHTMLAttributes<HTMLLIElement> {
  isActive: boolean;
  isFocused: boolean;
  isDisabled: boolean;
  item: T;
  onClick: () => void;
  onMouseEnter?: () => void;
  listItemRef: DropdownListProps<T>['listItemRef'];
  onMouseLeave: DropdownListProps<T>['onItemMouseLeave'];
  renderDropdownItem: DropdownListProps<T>['renderDropdownItem'];
  focusedItemClassName: DropdownListProps<T>['focusedItemClassName'];
  hasV2Styles?: boolean;
}

export const DropdownListOption = <T,>({
  isActive,
  isFocused,
  isDisabled = false,
  item,
  onClick,
  listItemRef,
  onMouseEnter,
  onMouseLeave,
  renderDropdownItem,
  focusedItemClassName,
  hasV2Styles,
}: DropdownListOptionProps<T>) => {
  return (
    <li
      role="option"
      aria-selected={isActive}
      data-testid="dropdown-list-option"
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      ref={isFocused || isActive ? listItemRef : undefined}
      onClick={isDisabled ? undefined : onClick}
      className={clsx(
        styles.listOption,
        {
          [styles.hasV2Styles]: hasV2Styles,
          [styles.disabled]: isDisabled,
        },
        isActive && 'active',
        isFocused && (focusedItemClassName || 'focused')
      )}
    >
      {renderDropdownItem(item, isActive, isFocused, isDisabled)}
    </li>
  );
};
